import WaveSurfer from 'wavesurfer.js';

/**
 * 停止音频播放 ，暂停其他播放源，包含视频和音频
 */
export const stopPlayer = () => new Promise<void>((resolve) => {
  stopMediaPlay().then(() => {
    wsPlayers.forEach((ws) => {
      if (ws.isPlaying()) {
        ws.pause();
      }
    });
    resolve();
  });
});

const stopMediaPlay = async () => {
  try {
    const videos = document.getElementsByTagName('video') as unknown as { pause: Function }[];
    const audios = document.getElementsByTagName('audio') as unknown as { pause: Function }[];
    const media = [...videos, ...audios];
    for (let i = 0; i < media.length; i++) {
      await stopPlay(media, i);
    }
  } catch (error) {
    console.error('Error stopping media player: ', error);
  }
};

const stopPlay = (media: { pause: Function }[], i: number) => new Promise((resolve, reject) => {
  try {
    media[i]?.pause();
    resolve(i);
  } catch (error) {
    reject(i);
  }
});

const wsPlayers = new Set<WaveSurfer>();

export const registerWsPlayer = (player: WaveSurfer) => {
  wsPlayers.add(player);

  return () => {
    wsPlayers.delete(player);
  };
};
